import React from 'react';
import './index.scss';
import EcoLink from 'eco-design/base/eco-link';
import EcoImg from 'eco-design/base/eco-img';
import { getCardAnimation } from '../common';

interface Props {
    prefixCls: string;
    item: any;
}

const CardTypeB: React.FC<Props> = ({ prefixCls, item }) => {
    const lItems = item.subs || [];

    let rItems: any[] = [];
    try {
        const extJson = item?.extJson;
        if (extJson && extJson.trim() !== '') {
            rItems = JSON.parse(extJson);
        } else {
            rItems = [];
        }
    } catch (e) {
        rItems = [];
    }

    console.log(lItems, rItems);

    // 有右侧列表

    if (lItems.length === 0) return <div className={`${prefixCls}-card-type-b`}></div>;
    return (
        <div className={`${prefixCls}-card-type-b`}>
            <div className={`${prefixCls}-card-type-b__grid`}>
                {lItems?.map?.((i: any, idx: number) => (
                    <EcoLink
                        className={`${prefixCls}-card-type-b__grid-item`}
                        style={{
                            animation: getCardAnimation(idx),
                        }}
                        href={i.url}
                        target="_blank"
                        key={i.id || idx}
                    >
                        <EcoImg className={`${prefixCls}-card-type-b__item-img`} pc={i.pictureUrl} />
                        <div className={`${prefixCls}-card-type-b__item-title`}>
                            <span>{i.heading}</span>
                        </div>
                    </EcoLink>
                ))}
            </div>
            <ul className={`${prefixCls}-card-type-b__right`}>
                {rItems?.map((i: any, idx: number) => (
                    <li
                        className={`${prefixCls}-card-type-b__right-item`}
                        style={{
                            animation: getCardAnimation(idx, lItems?.length),
                        }}
                        key={i.updateTime || idx}
                    >
                        <EcoLink className={`${prefixCls}-card-type-b__right-item-link`} href={i.url} target="_blank">
                            <EcoImg className={`${prefixCls}-card-type-b__right-item-icon`} pc={i.pictureUrl} />
                            <span className={`${prefixCls}-card-type-b__right-item-text`}>{i.name}</span>
                        </EcoLink>
                    </li>
                ))}
            </ul>
        </div>
    );
};
export default CardTypeB;
